import React, { useContext } from 'react';
import { SSRApiContext } from '@ecommerce/nest-ssr/common';
import ModalComponent from 'react-responsive-modal';

import ModalLayout from 'layouts/modal/modal';

import './modal.scss';

const closeIcon = (
    <i className="opicon-close"/>
);

const Modal: React.FC<{
    showCloseIcon: boolean;
    center: boolean;
    isOpen: boolean;
    onClose: () => void;
    shouldCloseOnOverlayClick: boolean;
    modalClassName: string;
    overlayClassName?: string;
    useModalLayout?: boolean;
    title?: string;
}> = props => {
    const api = useContext(SSRApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const overlay = props.overlayClassName;
    const classNames = {
        modal: `${props.modalClassName} ${api.getDevice() === 'desktop' ? 'desktop' : 'mobile'}`,
        overlay
    };

    return (
        <ModalComponent
            showCloseIcon={props.showCloseIcon}
            center={props.center}
            open={props.isOpen}
            onClose={props.onClose}
            closeIcon={closeIcon}
            classNames={classNames}
            closeOnOverlayClick={props.shouldCloseOnOverlayClick}
            focusTrapped={false}
        >
            {
                props.useModalLayout
                    ? (
                        <ModalLayout title={props.title}>
                            {props.children}
                        </ModalLayout>
                    )
                    : props.children
            }
        </ModalComponent>
    );
};

export default Modal;
